import { FETCH_AZ_LETTERS, AZ_LETTERS_IS_LOADING, AZ_LETTERS_HAS_ERRORED, AZ_FETCH_DATA_SUCCESS, AZ_IS_LOADING, AZ_HAS_ERRORED } from './types';
import { globalFetch } from './globalActions';

///////////
// AZ bottom of each page //
///////////

export function fetchAZLetters() {
	return globalFetch({
			urlPath: `smart_az`,
			reducerIsLoading: AZ_LETTERS_IS_LOADING,
			reducerError: AZ_LETTERS_HAS_ERRORED,
			dispatchSuccess: (itemObj, dispatch) => {
					dispatch({type: FETCH_AZ_LETTERS, payload: itemObj.a2z});
			}
	});
}


export function azFetchData(search) {
	return globalFetch({
			urlPath: `get_az_progs`,
			extraParams: `&${search}`,
			reducerIsLoading: AZ_IS_LOADING,
			reducerError: AZ_HAS_ERRORED,
			dispatchSuccess: (itemObj, dispatch) => {
					dispatch(azFetchDataSuccess(itemObj));
			}
	});
}

export function azFetchDataSuccess(items) {

	let cardItems = [];
	if(items.a2z_prog_listings.length > 0)
	{
		let id, title, subTitle, short_billing, thumbnail="default.jpg", isActions=true, isProgress=false, cardClass="card--small", progress=false;

		Object.entries(items.a2z_prog_listings).forEach(([key, value]) => {
			id = value.programme_id;
			title = value.series_title;
			subTitle = value.programme_title

			if (!title) {
				title = subTitle;
				subTitle = value.clic_aired;
			}
			if (!subTitle) {
				subTitle = value.clic_aired;
			}

			thumbnail = value.thumbnail_image;
			short_billing = value.short_billing;
		  	cardItems[key] = { id, title, subTitle, short_billing, thumbnail, isActions, isProgress, progress, cardClass };
		});
	}

	return {
		type: AZ_FETCH_DATA_SUCCESS,
		payload: cardItems
	};
}
